import {
  breakpointSizes,
  getBreakpointDown,
  styleConstants,
} from '@paywithextend/components'
import CloseButton from 'ext-ui/components/CloseButton/CloseButton'
import React from 'react'
import { useDispatch } from 'react-redux'
import NotFoundBottomContent from 'src/components/NotFoundBottomContent/NotFoundBottomContent'
import NotFoundTopContent from 'src/components/NotFoundTopContent/NotFoundTopContent'
import { closeModal } from 'src/navigation/Lnk'
import { css } from 'styled-components'

interface NotFoundRightFlyoutContentProps {
  className?: string
}

const NotFoundRightFlyoutContent: React.FC<NotFoundRightFlyoutContentProps> = (
  props,
): React.ReactElement => {
  const dispatch = useDispatch()

  return (
    <div
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;

        ${getBreakpointDown(breakpointSizes.XSM)(css`
          width: 100vw;
        `)}
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          padding: ${styleConstants.heights.rightFlyoutPaddingSMUp}
            ${styleConstants.widths.rightFlyoutPaddingSMUp};
          background-color: ${styleConstants.colors.white};
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
          z-index: 1;

          ${getBreakpointDown(breakpointSizes.XSM)(css`
            padding: 20px ${styleConstants.widths.rightFlyoutPaddingXSMDown};
          `)}
        `}
      >
        <CloseButton
          variant="dark-on-light"
          onClick={(): void => {
            dispatch(closeModal())
          }}
          css={css`
            margin-bottom: 20px;
          `}
        />
        <NotFoundTopContent
          css={css`
            align-self: center;
          `}
          isSmall
        />
      </div>
      <div
        css={css`
          flex-grow: 2;
          display: flex;
          justify-content: center;
          background-color: ${styleConstants.colors.gray_light};
          padding: ${styleConstants.heights.rightFlyoutPaddingSMUp}
            ${styleConstants.widths.rightFlyoutPaddingSMUp};

          ${getBreakpointDown(breakpointSizes.XSM)(css`
            padding: 20px ${styleConstants.widths.rightFlyoutPaddingXSMDown};
          `)}
        `}
      >
        <NotFoundBottomContent isFlyout />
      </div>
    </div>
  )
}

export default NotFoundRightFlyoutContent
